var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpField = require('./ReUpField.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var PlatformConstants = require('./constants/PlatformConstants');
var BundleInfo = require('./BundleInfo.js');
import Icon from './wrappers/ReUpIcon';

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKIconToggle
} = MK;

var FeedCard = require('./feedCard.js');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  StyleSheet,
  Keyboard,
  Platform,
} = ReactNative;

var DomainLogin = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      domain:"",
      username:"",
      password:"",
      headerImageMargin: new Animated.Value(20)
    }
  },

  _keyboardWillShowSubscription: null,
  _keyboardWillHideSubscription: null,
  componentDidMount : function()
  {
    var thisThing = this;
    this.props.appManager.getLastDomainEmail(function(domainEmailArray)
    {
      if( domainEmailArray == null || domainEmailArray.length != 2 )
      {

      }
      else
      {
        thisThing.props.appManager.getCurrentUser(function(currentUser)
        {
          thisThing.setState({domain:domainEmailArray[0], username:domainEmailArray[1]});
          if( currentUser && currentUser != null )
          {
            thisThing.props.appManager._domain = domainEmailArray[0];
            thisThing.props.appActions.requestFeatureName("TransactionScan", {}, false);
          }
        });
      }
    })

    this._keyboardWillShowSubscription = Keyboard.addListener('keyboardDidShow', (e) => this._keyboardWillShow(e));
    this._keyboardWillHideSubscription = Keyboard.addListener('keyboardDidHide', (e) => this._keyboardWillHide(e));
  },

  componentWillUnmount : function() {
    this._keyboardWillShowSubscription.remove();
    this._keyboardWillHideSubscription.remove();
  },

  didUpdate(data) {

  },

  _keyboardWillShow : function(e)
  {
    var newHeight = this.state.layout.height - e.endCoordinates.height;
    var headerImageMargin = Math.max(-58, Math.min(20, newHeight - 380))

    Animated.spring(this.state.headerImageMargin,
    {
      toValue: headerImageMargin,
      friction: 6
    }).start();
  },

  _keyboardWillHide : function(e)
  {
    Animated.spring(this.state.headerImageMargin,
    {
      toValue: 20,
      friction: 6
    }).start();
  },

  _showPassword : false,
  _currentPassword : "",
  _newPassword : "",
  _currentPasswordError: false,
  _newPasswordError: false,
  showChangePass : function()
  {
    var thisThing = this;
    var appManager = thisThing.props.appManager;
    var appActions = thisThing.props.appActions;
    var locManager = thisThing.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");

    var locMan = appManager.getLocalizationManager();
    var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
    var newPassDescription = locMan.localizedStringForKey("SET_NEW_PASSWORD_STATEMENT");
    var newPassPlaceholder = locMan.localizedStringForKey("NEW_PASSWORD_PLACEHOLDER");
    var currPass = appManager.currentUser()[ModelConstants.Password];

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:2,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View >
          <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} isTitle={true} style={{marginTop:10, textAlign:'center'}}>
            {locMan.localizedStringForKey("CHANGE_PASS_STATEMENT")}
          </ReUpText>
          <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{marginTop:10, textAlign:'center'}}>
            {newPassDescription}
          </ReUpText>
          <View style={{flexDirection:'row'}}>
            <ReUpField
              onChangeText={(text) => {this._newPassword = text}}
              key="password"
              ref={(a) => thisThing._passwordField = a}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor, fontFamily:'Arial'}}
              appManager={appManager}
              placeholder={newPassPlaceholder}
              secureTextEntry={!this._showPassword}
              style={[{marginRight:4}]}/>

            <MKIconToggle
              style={[{marginTop:10}, {marginTop:22, height:30, width:30}]}
              checked={this._showPassword}
              onCheckedChange=
              {
                (info) => {
                  thisThing._passwordField.onBlur();
                  thisThing._showPassword = info.checked;
                  thisThing.showChangePass();
                }
              }
              >
              <Icon pointerEvents="none" state_checked={true} style={[styles.creditCardEditButtonIcon]} name={"eye"} size={14} color={generalTitleColor} />
              <Icon pointerEvents="none" state_checked={false} style={[styles.creditCardEditButtonIcon]} name={"eye-slash"} size={14} color={generalTitleColor} />
            </MKIconToggle>

          </View>
          <ReUpButton onPress={() =>
            {
              appActions.hideAlert();
              if( appManager.isValidPassword(thisThing._newPassword) )
              {
                thisThing.changePassword(thisThing._newPassword);
              }
              else
              {
                appActions.showLocalizedAlert("CHANGE_PASS_FORMAT_FAIL_ALERT_TITLE","CHANGE_PASS_FORMAT_FAIL_ALERT_BODY",["OK_ALERT_BUTTON"],[thisThing.showChangePass], function(){})
              }
            }} appManager={this.props.appManager} text={changePasswordButton} style={[styles.logoutButton, {marginTop:10, marginBottom:10}]} />
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function(){appActions.requestPop(true);});
  },

  changePassword: function(newPass)
  {
    var thisThing = this;
    var appManager = thisThing.props.appManager;
    var appActions = thisThing.props.appActions;
    var locMan = appManager.getLocalizationManager();
    var changingPassword = locMan.localizedStringForKey("SAVING_HUD");
    thisThing.props.appActions.setSpinnerShown(true, changingPassword)
    NetworkManager.changePassword(this.props.appManager, newPass, function()
    {
      thisThing.props.appActions.setSpinnerShown(false);
      var user = appManager.getCurrentUser(function(currentUser)
      {
        currentUser[ModelConstants.Password] = newPass;
        appManager.setCurrentUser(currentUser, function()
        {
          var changePassSuccessTitle = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_TITLE");
          var changePassSuccessBody = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_BODY");
          var okayButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");

          thisThing.props.appActions.showAlert(changePassSuccessTitle, changePassSuccessBody, [okayButton], [function(){thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false); appActions.requestPop(true);}], function(){appActions.setSpinnerShown(false); appActions.requestPop(true);})
        });
      })
    }, function(data)
    {
      thisThing.props.appActions.setSpinnerShown(false);
      var title = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_TITLE");
      var body = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_BODY");
      var okayButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");

      thisThing.props.appActions.showAlert(title, body, [okayButton], [function(){thisThing.showChangePass()}], function(){thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false); appActions.requestPop(true);})
    }, function()
    {
      thisThing.props.appActions.setSpinnerShown(false);
      thisThing.props.appActions.showNetworkErrorAlert(function(){thisThing.showChangePass()}, function(){thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false); appActions.requestPop(true);});
    },)
  },

  _lastDoubleTouch : -1,
  _doubleTouchCount : 0,
  MULTI_TOUCH_TIME_THRESHOLD : 500,
  DEBUG_MENU_NUMBER_OF_TOUCHES : 5,
  showDebugIfEnoughTouches : function(timestamp)
  {
    // touch too long, reset
    if( this._lastDoubleTouch > 0 && (timestamp - this._lastDoubleTouch) > this.MULTI_TOUCH_TIME_THRESHOLD)
    {
      this._doubleTouchCount = 0;
      this._lastDoubleTouch = -1;
    }

    // show info
    this._doubleTouchCount++;
    if( this._doubleTouchCount >= this.DEBUG_MENU_NUMBER_OF_TOUCHES )
    {
      this._doubleTouchCount = 0;
      this._lastDoubleTouch = -1;
      var appManager = this.props.appManager;
      var resourceInfo = appManager.getResourceInfo();
      this.props.appActions.setCustomAlertShown(true, <View><Text style={{fontSize:12}}>{"Bundle Info\n\n" + BundleInfo + "\nResource Info\n\n" + resourceInfo}</Text></View>);
      return;
    }

    this._lastDoubleTouch = timestamp;
  },

  doLogin: function()
  {
    Keyboard.dismiss();
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var thisThing = this;
    var loggingIn = appManager.getLocalizationManager().localizedStringForKey("LOGIN_HUD");
    appActions.setSpinnerShown(true, loggingIn);
    NetworkManager.domainLogin(appManager, thisThing.state.domain, thisThing.state.username, thisThing.state.password,
    function(data)
    {
      if( data.Admin != "1" )
      {
        appActions.setSpinnerShown(false);
        appActions.showLocalizedAlert("NON_AMIN_USER_ALERT_TITLE", "NON_AMIN_USER_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
        return;
      }
      appManager.setLastDomainEmail([thisThing.state.domain, thisThing.state.username], function()
      {
        data[ModelConstants.Password] = thisThing.state.password;
        appManager.setCurrentUser(data, function()
        {
          appActions.setSpinnerShown(false);
          if( data[ModelConstants.DirtyPassword] == 1 )
          {
            thisThing.showChangePass();
          }
          else
          {
            setTimeout(function(){thisThing.setState({password:""}),1000});
            thisThing.props.appActions.requestFeatureName("TransactionScan");
          }
        })
      });
    },
    function(data)
    {
      appActions.setSpinnerShown(false);
      if( data.code == -23 ) // not verified
      {
        appActions.showLocalizedAlert("UNVERIFIED_FAIL_ALERT_TITLE", "UNVERIFIED_FAIL_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [appActions.hideAlert, function()
        {
          appActions.setSpinnerShown(true, "");
          NetworkManager.resendVerifyEmail(appManager, thisThing.state.username, function()
          {
            appActions.showLocalizedAlert("EMAIL_PASS_SUCCESS_ALERT_TITLE", "CREATEUSER_SUCCESS_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
            appActions.setSpinnerShown(false);
          }, function()
          {
            appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
            appActions.setSpinnerShown(false);
          }, function()
          {
            appActions.showNetworkErrorAlert(appActions.hideAlert, function(){});
            appActions.setSpinnerShown(false);
          })
        }], appActions.hideAlert)
      }
      else
      {
        appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
      }
    },
    function(data)
    {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
    })
  },

  render: function()
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var subdomainPlaceholder = locManager.localizedStringForKey("SUBDOMAIN_PLACEHOLDER");
    var emailPlaceholder = locManager.localizedStringForKey("EMAIL_PLACEHOLDER");
    var passwordPlaceholder = locManager.localizedStringForKey("PASSWORD_PLACEHOLDER_SIMPLE");
    var loginButton = locManager.localizedStringForKey("LOGIN_BUTTON");
    var appActions = this.props.appActions;
    var feedFeatureData = appManager.getFeatureForName("DomainLogin");
    var thisThing = this;

    var cardColor = appManager.getColorForKey("FeedCardColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");

    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);
    var headerImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/header.png");

    var fieldWidth = this.state.layout.width - 100;

    return (
      <View style={[styles.container]}>
        <View
          style={[styles.image,{width:this.state.layout.width, height:this.state.layout.height, backgroundColor:generalColor}]}
        />
        <ReUpScrollView ref={(a)=>{if( a != null ) a.setRefreshEnabled(false)}} bounces={false} responder={this}>
          <Animated.View style={{width:150, alignSelf:'center', marginTop:this.state.headerImageMargin}}>
            <Image  key={appManager.getImageKey("header")} onStartShouldSetResponder={(evt) => {if( evt.nativeEvent.identifier == 2 || (Platform.OS != "ios" && evt.nativeEvent.identifier == 1)) thisThing.showDebugIfEnoughTouches(evt.nativeEvent.timestamp)}}
              style={{width:150, height:78}}
              source={{uri: headerImage}}
            />
          </Animated.View>
          <View style={{flexDirection:'column', margin:10, borderRadius:10, backgroundColor:'white'}}>
            <View style={{margin:10}}>
              <View style={{flexDirection:'row', alignItems:'center'}}>
                <ReUpField
                  key={"Domain"+fieldWidth}
                  appManager={appManager}
                  onChangeText={(text) => {thisThing.setState({domain:text})}}
                  placeholder={subdomainPlaceholder}
                  autoCapitalize={'none'}
                  autoCorrect={false}
                  style={[{
                    flex:1,
                    width:-1,
                    height:50,
                    marginTop:10
                  }]}
                  value={thisThing.state.domain}
                  onSubmitEditing={() => this.refs["email"].focus()}/>
              </View>
              <ReUpField
                ref="email"
                key={"Email"+fieldWidth}
                appManager={appManager}
                onChangeText={(text) => {thisThing.setState({username:text})}}
                placeholder={emailPlaceholder}
                autoCapitalize={'none'}
                autoCorrect={false}
                keyboardType={'email-address'}
                style={[{
                  flex:1,
                  width:-1,
                  height:50,
                  marginTop:10
                }]}
                value={thisThing.state.username}
                onSubmitEditing={() => this.refs["password"].focus()}/>
              <ReUpField
                ref="password"
                key={"Password"+fieldWidth}
                appManager={appManager}
                onChangeText={(text) => {thisThing.setState({password:text})}}
                placeholder={passwordPlaceholder}
                secureTextEntry={true}
                returnKeyType={"done"}
                style={[{
                  flex:1,
                  width:-1,
                  height:50,
                  marginTop:10
                }]}
                value={thisThing.state.password}
                onSubmitEditing={this.doLogin}/>
            </View>
          </View>

          <ReUpButton style={[styles.button,{ margin:10}]}
            appManager={appManager}
            text={loginButton}
            onPress={this.doLogin}
            />
          </ReUpScrollView>
        </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:0,//Globals.ACTION_BAR_HEIGHT,
  },
  image: {
    position: 'absolute',
  },
});


DomainLogin.dataDependencies = []

module.exports = DomainLogin;



// WEBPACK FOOTER //
// ./src/DomainLogin.js